import { render, staticRenderFns } from "./IframelyEmbed.vue?vue&type=template&id=adb53146&shadow"
import script from "./IframelyEmbed.js?vue&type=script&lang=js&shadow"
export * from "./IframelyEmbed.js?vue&type=script&lang=js&shadow"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  ,true
)

export default component.exports